import { CbhFeatureFlag } from "./CbhFeatureFlag";
import { useCbhFlag } from "./useCbhFlag";

const DEFAULT_WORKER_PAY_SURVEY_CONFIG = {
  variation: "off" as const,
};

export function useWorkerPaySurveyFlag() {
  return useCbhFlag(CbhFeatureFlag.WORKER_PAY_SURVEY_CONFIG, {
    defaultValue: DEFAULT_WORKER_PAY_SURVEY_CONFIG,
  });
}
